// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import MarkDown from "components/ui/MarkDown";
import React from "react";
import { fbt } from "fbt";
import { useTestRunState } from "store/testrun";

const WriteDOBForProfileString: React.FunctionComponent = () => {
  const testRunState = useTestRunState();
  const firstname = testRunState.testRun?.profileDetails?.firstname;
  let markdown;
  if (firstname) {
    markdown = fbt(
      `Write the **date of birth** for ` +
        fbt.param("first name", firstname) +
        ` on the tube label in the format of mm/dd/yyyy.`,
      "Healthpulse write name: write date of birth instruction (markdown)"
    );
  } else {
    markdown = fbt(
      `Write the **date of birth** on the tube label in the format of mm/dd/yyyy.`,
      "Healthpulse write name: write date of birth instruction (markdown)"
    );
  }

  return <MarkDown source={markdown} />;
};

export default WriteDOBForProfileString;
